/**
 * This hook is used in Merchant Orientation, so that we only show
 * disputes-related orientation if the current user has any unresolved
 * disputes. The hook was contributed by Merchant Education & Growth,
 * but is now owned by team Disputes. (March 2020)
 */
import { useStore } from 'react-redux'
import { useState, useEffect } from 'react'

import { selectors as coreSelectors } from 'mage-core'
import * as Sentry from '@sentry/react'

import useAvailableApps from './useAvailableApps'

async function getPendingDisputes (client, setIsloading, setDisputesCount) {
  setIsloading(true)
  try {
    const pendingDisputes = await client.request({
      method: 'POST',
      url: '/v3/disputes/search',
      data: {
        investigation_status: 'unresolved',
        sort_options: [
          { field: 'investigation_deadline_expires_at', direction: 'asc' }
        ]
      }
    })

    const count = pendingDisputes.data.pagination.total
    setDisputesCount(count)
  } catch (e) {
    Sentry.captureException(e)
    setDisputesCount(0)
  } finally {
    setIsloading(false)
  }
}

function useUnresolvedDisputesCount (tokenHelper) {
  const store = useStore()
  const [disputesCount, setDisputesCount] = useState(null)
  const [isLoading, setIsloading] = useState(false)
  const availableApps = useAvailableApps(tokenHelper)

  const isDisputesAvailable = availableApps.includes('disputes-fe')

  useEffect(() => {
    if (isDisputesAvailable) {
      const state = store.getState()
      const client = coreSelectors.createBackendClient(state)('disputes')
      getPendingDisputes(client, setIsloading, setDisputesCount)
    }
  }, [store])

  return { data: disputesCount, isLoading }
}

export default useUnresolvedDisputesCount
